<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-row class="align-items-center">
          <b-col>
            <h3 class="m-0">Gerenciamento de Atendimentos</h3>
          </b-col>
          <b-col class="text-right">
            <b-button variant="secondary" v-b-modal.mdlFiltros class="mr-2">
              Filtros
            </b-button>
            <b-button variant="primary" @click="novoAtendimento">
              Novo
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <b-alert
          v-if="selecionados.length && temFuncao('Administrador')"
          show
          variant="light"
          class="d-flex justify-content-between align-items-center mb-3 text-dark"
        >
          <div>
            <strong>{{ selecionados.length }}</strong>
            registro(s) selecionado(s)
          </div>

          <div>
            <b-button size="sm" variant="danger" @click="cancelarSelecionados">
              Cancelar
            </b-button>

            <b-button
              size="sm"
              variant="secondary"
              class="ml-2"
              @click="limparSelecao"
            >
              Limpar seleção
            </b-button>
          </div>
        </b-alert>

        <b-table
          :items="atendimentos"
          :fields="fields"
          :busy="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting
          show-empty
          responsive
        >
          <template #empty>
            <div class="text-center">Nenhum registro encontrado.</div>
          </template>

          <template #head(selecionar)>
            <b-form-checkbox
              :indeterminate="indeterminate"
              :checked="todosSelecionados"
              @change="selecionarTodos"
              size="lg"
            />
          </template>

          <template #cell(selecionar)="row">
            <b-form-checkbox
              :value="row.item.id"
              v-model="selecionados"
              size="lg"
            />
          </template>

          <template v-slot:cell(status_id)="data">
            <b-badge variant="danger" v-if="data.value === 'C'">
              {{ data.item.status?.nome }}
            </b-badge>
            <b-badge variant="success" v-else-if="data.value === 'F'">
              {{ data.item.status?.nome }}
            </b-badge>
            <b-badge variant="warning" v-else-if="data.value === 'A'">
              {{ data.item.status?.nome }}
            </b-badge>
          </template>

          <template v-slot:cell(acao)="data">
            <b-dropdown
              variant="clean"
              size="small"
              toggle-class="btn-icon"
              no-caret
            >
              <template #button-content>
                <i class="fas fa-ellipsis-h"></i>
              </template>

              <b-dropdown-item
                @click="imprimirSenha(data.item)"
                v-if="!['C', 'F'].includes(data.item.status_id)"
              >
                Imprimir Senha
              </b-dropdown-item>

              <b-dropdown-item
                @click="imprimir(data.item.id)"
                v-if="
                  data.item.status_id === 'F' &&
                  temPermissao('atendimento.imprimir')
                "
              >
                Imprimir Ficha
              </b-dropdown-item>

              <b-dropdown-item
                @click="editarAtendimento(data.item)"
                v-if="
                  data.item.status_id === 'A' ||
                  (data.item.status_id === 'F' &&
                    temPermissao('atendimento.editar'))
                "
              >
                Editar
              </b-dropdown-item>

              <b-dropdown-item
                @click="excluir(data.item.id)"
                variant="danger"
                v-if="false"
              >
                Excluir
              </b-dropdown-item>

              <b-dropdown-item
                @click="cancelar(data.item.id)"
                v-if="data.item.status_id === 'A'"
              >
                Cancelar
              </b-dropdown-item>

              <b-dropdown-item
                @click="ativar(data.item.id)"
                v-if="data.item.status_id === 'C'"
              >
                Ativar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-card-body>

      <b-card-footer>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="m-0"
          ></b-pagination>

          <div class="d-flex align-items-center flex-wrap">
            <b-select v-model="perPage" size="sm" class="mr-4 select-per-page">
              <option
                v-for="option in [20, 50, 100]"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>

            <span>
              Exibindo de {{ fromPage }} até {{ toPage }} de
              {{ totalRows }} registros.
            </span>
          </div>
        </div>
      </b-card-footer>
    </b-card>

    <b-modal
      id="mdlFiltros"
      ref="mdlFiltros"
      title="Filtros"
      ok-title="Filtrar"
      @ok="getAtendimentos"
      @shown="validacao"
      cancel-title="Cancelar"
    >
      <b-form-group label="Nome do paciente:">
        <b-form-input v-model="filtros.nomePaciente" size="sm"></b-form-input>
      </b-form-group>

      <b-row>
        <b-col cols="6">
          <b-form-group label="CPF:">
            <b-form-input
              v-model="filtros.cpf"
              size="sm"
              data-inputmask="'alias': 'cpf'"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Cartão do SUS:">
            <b-form-input
              v-model="filtros.cartaoSUS"
              size="sm"
              data-inputmask="'alias': 'cartao_sus'"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Data de cadastro:">
        <b-row>
          <b-col cols="6">
            <b-form-datepicker
              v-model="filtros.dataCadastroInicio"
              size="sm"
            ></b-form-datepicker>
          </b-col>

          <b-col cols="6">
            <b-form-datepicker
              v-model="filtros.dataCadastroFim"
              size="sm"
            ></b-form-datepicker>
          </b-col>
        </b-row>
      </b-form-group>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Cadastrado por:">
            <b-form-select
              v-model="filtros.usuarioCadastro"
              :options="usuariosRecepcao"
              text-field="nome"
              value-field="id"
              size="sm"
            >
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Atendido por:">
            <b-form-select
              v-model="filtros.usuarioAtendimento"
              :options="usuariosAtendimento"
              text-field="nome"
              value-field="id"
              size="sm"
            >
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Status:">
            <b-form-select
              v-model="filtros.status"
              :options="status"
              text-field="nome"
              value-field="id"
              size="sm"
            >
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <atendimento-formulario
      ref="mdlAtendimentoFormulario"
      @atualizar="getAtendimentos"
      :procedimentos="procedimentos"
      :unidades="unidades"
    ></atendimento-formulario>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AtendimentoService from "@/core/services/atendimento.service";
import AtendimentoFormulario from "./AtendimentoFormulario.vue";
import moment from "@/core/plugins/moment";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import Inputmask from "@/core/plugins/inputmask";

export default {
  name: "atendimento-listar",

  components: {
    AtendimentoFormulario,
  },

  data() {
    return {
      atendimentos: [],
      loading: false,
      fields: [
        {
          key: "selecionar",
          label: "",
          thStyle: {
            width: "45px",
          },
        },
        {
          key: "data_cadastro",
          label: "Data",
          class: "text-center align-middle",
          sortable: true,
          formatter: "dataHoraFormatter",
        },
        {
          key: "paciente.nome",
          label: "Paciente",
          sortable: true,
          class: "align-middle",
        },
        {
          key: "usuario_cadastro.nome",
          label: "Cadastrado por",
          sortable: true,
          class: "align-middle",
        },
        {
          key: "usuario_atendimento.nome",
          label: "Atendido por",
          sortable: true,
          class: "align-middle",
        },
        {
          key: "status_id",
          label: "Status",
          sortable: true,
          class: "text-center align-middle",
        },
        { key: "acao", label: "Ação", class: "text-center align-middle" },
      ],
      totalRows: 0,
      toPage: 0,
      fromPage: 0,
      currentPage: 1,
      perPage: 20,
      sortBy: "data_cadastro",
      sortDesc: false,
      filtros: {
        nomePaciente: null,
        cpf: null,
        cartaoSUS: null,
        dataCadastroInicio: null,
        dataCadastroFim: null,
        usuarioCadastro: null,
        usuarioAtendimento: null,
        status: null,
      },
      usuariosRecepcao: [],
      usuariosAtendimento: [],
      status: [],
      procedimentos: [],
      unidades: [],
      selecionados: [],
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Gerenciamento de Atendimentos",
      },
    ]);

    this.getAtendimentos();
  },

  methods: {
    getAtendimentos() {
      this.loading = true;
      this.selecionados = [];

      AtendimentoService.getAtendimentos({
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        ...Object.flatten(Object.filter(this.filtros), "filtros"),
      })
        .then(({ data }) => {
          this.atendimentos = data.atendimentos.data;
          this.totalRows = data.atendimentos.total;
          this.toPage = data.atendimentos.to;
          this.fromPage = data.atendimentos.from;
          this.usuariosRecepcao = data.usuariosRecepcao;
          this.usuariosAtendimento = data.usuariosAtendimento;
          this.status = data.status;
          this.procedimentos = data.procedimentos;
          this.unidades = data.unidades;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    novoAtendimento() {
      this.$refs.mdlAtendimentoFormulario.exibirModal();
    },

    editarAtendimento(atendimento) {
      this.$refs.mdlAtendimentoFormulario.exibirModal(atendimento);
    },

    async excluir(id) {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja realmente excluir este atendimento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(async (result) => {
        if (result.value) {
          await AtendimentoService.excluir(id).then(() => {
            Swal.fire(
              "Sucesso!",
              "Atendimento excluído com sucesso.",
              "success"
            );
            this.getAtendimentos();
          });
        }
      });
    },

    async cancelar(id) {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja realmente cancelar este atendimento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(async (result) => {
        if (result.value) {
          await AtendimentoService.cancelar(id).then(() => {
            Swal.fire(
              "Sucesso!",
              "Atendimento cancelado com sucesso.",
              "success"
            );
            this.getAtendimentos();
          });
        }
      });
    },

    async ativar(id) {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja realmente ativar este atendimento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(async (result) => {
        if (result.value) {
          await AtendimentoService.ativar(id).then(() => {
            Swal.fire(
              "Sucesso!",
              "Atendimento ativado com sucesso.",
              "success"
            );
            this.getAtendimentos();
          });
        }
      });
    },

    async imprimir(atendimentoId) {
      this.showOverlay();

      await AtendimentoService.imprimir(atendimentoId)
        .then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .finally(() => {
          this.hideOverlay();
        });
    },

    imprimirSenha(atendimento) {
      const html = `
      <html>
      <head>
        <title>Senha</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          @page {
            margin: 0;
          }

          body {
            font-family: monospace;
            text-align: center;
            width: 100%;
          }

          .container {
            width: 72mm; /* 72mm = bobina 80mm | use 48mm para 58mm */
            padding: 3mm 2mm;
            margin: 0 auto;
          }

          .titulo {
            font-size: 12px;
            font-weight: bold;
            letter-spacing: 1px;
          }

          .linha {
            border-top: 1px dashed #000;
            margin: 6px 0;
          }

          .senha {
            font-size: 60px;
            font-weight: bold;
            line-height: 1;
            margin: 8px 0;
          }

          .info {
            font-size: 12px;
            margin-top: 4px;
            word-wrap: break-word;
          }

          .rodape {
            font-size: 11px;
            margin-top: 6px;
          }

          .container, .container * {
            page-break-inside: avoid;
          }
        </style>
      </head>

      <body>

        <div class="container">
          <div class="titulo">SENHA DE ATENDIMENTO</div>

          <div class="linha"></div>

          <div class="senha">${atendimento.senha}</div>

          <div class="linha"></div>

          <div class="info">PACIENTE:<br>${atendimento.paciente.nome}</div>

          <div class="info">
            DATA/HORA:<br>${moment(atendimento.data_cadastro).format(
              "DD/MM/YYYY HH:mm:ss"
            )}
          </div>

          <div class="linha"></div>

          <div class="rodape">Aguarde ser chamado</div>
        </div>

      </body>
      </html>
    `;

      const left = (screen.width - 800) / 2;
      const win = window.open(
        "",
        "popup",
        `width=${800},height=${600},top=10,left=${left}`
      );
      win.document.write(html);
      win.document.close(); //this seems to be the thing doing the trick
      win.focus();
      win.print();
      win.close();
    },

    dataFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "";
    },

    dataHoraFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "";
    },

    showOverlay() {
      this.$store.dispatch("toggleOverlay", {
        value: true,
        message: "Processando, aguarde...",
      });
    },

    hideOverlay() {
      this.$store.dispatch("toggleOverlay", { value: false });
    },

    validacao() {
      this.$nextTick(() => {
        Inputmask().mask(document.querySelectorAll("[data-inputmask]"));
      });
    },

    selecionarTodos(valor) {
      if (valor) {
        this.selecionados = this.atendimentos.map((item) => item.id);
      } else {
        this.selecionados = [];
      }
    },

    cancelarSelecionados() {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja realmente cancelar os atendimentos selecionados?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(async (result) => {
        if (result.value) {
          await AtendimentoService.cancelarSelecionados(this.selecionados).then(
            () => {
              Swal.fire(
                "Sucesso!",
                "Atendimentos cancelados com sucesso.",
                "success"
              );
              this.getAtendimentos();
            }
          );
        }
      });
    },

    limparSelecao() {
      this.selecionados = [];
    },
  },

  watch: {
    currentPage() {
      this.getAtendimentos();
    },

    perPage() {
      this.getAtendimentos();
    },

    sortBy() {
      this.getAtendimentos();
    },

    sortDesc() {
      this.getAtendimentos();
    },
  },

  computed: {
    ...mapGetters(["temPermissao", "temFuncao"]),

    todosSelecionados() {
      return (
        this.atendimentos.length > 0 &&
        this.selecionados.length === this.atendimentos.length
      );
    },

    indeterminate() {
      return this.selecionados.length > 0 && !this.todosSelecionados;
    },

    registrosSelecionados() {
      return this.atendimentos.filter((item) =>
        this.selecionados.includes(item.id)
      );
    },
  },
};
</script>

<style scoped>
.select-per-page {
  height: calc(1.244em + 1.1rem + 2px) !important;
  width: 70px !important;
}
</style>
